/**
 * @generated SignedSource<<66da1ea1509485784e5ab2612e05e5c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type useIsGolfFacility_facility$data = {
  readonly type: FacilityType;
  readonly " $fragmentType": "useIsGolfFacility_facility";
};
export type useIsGolfFacility_facility$key = {
  readonly " $data"?: useIsGolfFacility_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsGolfFacility_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsGolfFacility_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "451ddf9798bef49f3fed25249cf312a8";

export default node;
